import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { useQuery } from '@apollo/client';
import { obtenerWordpressMenu } from '../../utilerias/buscadorGeneral';
import MenuOnDrawer from './MenuOnDrawer';

const useStyles = makeStyles((theme) => ({
    menuButton: {
        margin: theme.spacing(1),
        marginLeft: "0px",
        paddingLeft: "0px",
        marginRight: "0px",
        paddingRight: "0px",
        backgroundColor: "transparent",
        border: "none !important",
        boxShadow: "none",
        color: "#116F5C"
    }
}));

const estiloSpan = {
    height: "25px",
    fontSize: "calc(3.333vw + 3px)",
    alignItems: "center",
    textTransform: "uppercase",
    paddingRight: "calc(21vw - 40px)",
    color: "rgb(197, 107, 22)"
};

const MenuMovil = (props) => {
    const { loading, error, data } = useQuery(obtenerWordpressMenu, { options: { fetchPolicy: 'no-cache' } })
    const classes = useStyles()
    return (
        <>
            {
                !loading && !error && data &&
                <>
                    <IconButton
                        edge="end"
                        className={`openMenuMovilIcon ${classes.menuButton}`}
                        aria-label="open drawer"
                        onClick={props.openDrawer}
                        size="medium"
                    >
                        <span style={estiloSpan} class="MuiIconButton-label">
                        El colegio de la frontera sur
                        </span>
                        <MenuIcon fontSize='large' />
                    </IconButton>
                    <MenuOnDrawer {...props} data={data.menuWP} />
                </>
            }
        </>
    );
}

export default MenuMovil;